import { createFileRoute } from '@tanstack/react-router'
import { GeneralTab } from '@/pages/donor-detail/ui/GeneralTab'

function GeneralTabRoute() {
  const { visitId } = Route.useParams()
  return <GeneralTab visitId={visitId} />
}

export const Route = createFileRoute(
  '/_protected/labarotaroyResearch/$visitId/',
)({
  component: GeneralTabRoute,
})
